<template>
  <div>
    <div class="level">
      <header class="title is-5">
        Unassigned Tasks
      </header>
      <button
        :disabled="selected.length == 0" 
        @click="bulkAssigning = true"
        class="button is-primary">
        Bulk Assign {{ selected.length }} tasks
      </button>
    </div>


    <article 
      v-if="!firstLoad && masterProductions.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There are no unassigned tasks.
      </div>
    </article>

    <table 
      v-if="!firstLoad && masterProductions.length > 0" 
      class="table is-hoverable is-clickable is-fullwidth has-smallish-font">
      <thead>
        <th 
          v-for="(header, headerIndex) in headers"
          :key="headerIndex">
          {{ header }}
        </th>
      </thead>
      <tbody>
        <template v-for="taskGroup in masterProductions">
          <tr 
            v-if="taskGroup.production_steps.length > 0"
            class="has-background-light subheader"
            :key="taskGroup.id">
            <td></td>
            <td :colspan="headers.length - 1">
              <router-link :to="taskNavigation(taskGroup)">
                {{ taskGroup.project.project_name }} ({{ taskSource(taskGroup) }})
              </router-link>
            </td>
          </tr>
          <tr
            class="v-centered is-size-6"
            v-for="task in taskGroup.production_steps"
            :key="task.id">
            <td>
              <v-checkbox 
                :value="selected.includes(task.id)"
                @input="toggleSelected(task.id)"
                class="mr-3"/>
            </td>
            <td>
              {{ task.step.work_name }}
            </td>
            <td>
              {{ task.exp_duration_min_str }}
            </td>
            <td>
              {{ task.qty_unassigned }}
            </td>
            <td>
              <div class="buttons buttons-right">
                <button
                  @click="assigningTask = task; assigning = true;" 
                  class="button is-small has-text-grey">
                  <span class="icon ">
                    <i class="fas fa-arrow-right"></i>
                  </span>
                  <span>
                    Assign to Workstation
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <assign-task-modal
      :task="assigningTask"
      v-model="assigning"/>

    <bulk-assign-tasks-modal
      v-model="bulkAssigning"/>

  </div>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'
import AssignTaskModal from '@/components/scheduling/AssignTaskModal'
import BulkAssignTasksModal from '@/components/scheduling/BulkAssignTasksModal'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: { VCheckbox, AssignTaskModal, BulkAssignTasksModal },
  data() {
    return {
      headers: [
        '', 'Task', 'Exp. Duration', 'Unassigned Quantity', ''
      ],
      assigningTask: null,
      assigning: false,
      bulkAssigning: false
    }
  },
  computed: {
    ...mapState("masterProductions", [
      "masterProductions", "firstLoad", "selected"
    ]),
    ...mapGetters("masterProductions", ["stepsSelected"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("masterProductions", [
      "getMasterProductions"
    ]),
    ...mapMutations("masterProductions", [
      "toggleSelected"
    ]),
    initialize() {
      this.getMasterProductions({
        is_fully_assigned: false
      });  
    },
    taskSource(taskGroup) {
      if (taskGroup.part_type == 'production_sheet_item_id') {
        return 'Production Sheet'
      } else if (taskGroup.part_type == 'cutsheetpart_id') {
        return 'Cut Sheet'
      } else if (taskGroup.part_type == 'assemblysheet_id') {
        return 'Assembly Sheet'
      }
    },
    taskNavigation(taskGroup) {
      if (taskGroup.part_type == 'production_sheet_item_id') {
        return {
          name: 'ProductionSheetViewer',
          params: {
            productionSheetId: taskGroup.production_sheet_item.production_sheet.id
          }
        }
      } else if (taskGroup.part_type == 'cutsheetpart_id') {
        return {
          name: 'CutSheetViewer',
          params: {
            cutSheetId: taskGroup.cutsheet_part.cutsheet.id
          }
        }
      } else if (taskGroup.part_type == 'assemblysheet_id') {
        return {
          name: 'AssemblyView',
          params: {
            assemblySheetId: taskGroup.assembly_sheet_id
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>